import request from "@/router/axios";
import axios from "axios";

const documentmanagerurl = "/sg-user-service/v1/literature";

export function listBase(isLogin, lang, cateId) {
  return request({
    url: documentmanagerurl + "/listBase",
    method: "get",
    params: {
      langCode: lang || "en",
      isLogin: isLogin,
      cateId: cateId
    }
  });
}

export function listTechnical(
  loginView,
  fileType,
  langCode,
  fileName,
  tagId,
  categoryId,
  pageNum,
  pageSize
) {
  return request({
    url: documentmanagerurl + "/listTechnical",
    method: "get",
    params: {
      loginView: loginView,
      fileType: fileType,
      langCode: langCode || "en",
      fileName: fileName,
      tagId: tagId,
      categoryId: categoryId,
      pageNum: pageNum,
      pageSize: pageSize
    }
  });
}

export function downloadLocalPdf(id, name) {
  const url = documentmanagerurl + "/downloadLocalPdf" + "/" + id;
  axios({
    method: "get",
    url: url,
    responseType: "blob"
  }).then(res => {
    // 处理数据，并下载
    const blob = new Blob([res.data]);
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  });
}
export function downloadLocalZip(id, name) {
  const url = documentmanagerurl + "/downloadLocalZip" + "/" + id;
  axios({
    method: "get",
    url: url,
    responseType: "blob"
  }).then(res => {
    // 处理数据，并下载
    const blob = new Blob([res.data]);
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  });
}



// WEBPACK FOOTER //
// ./src/api/sigen/documentCenter.js